import { useState, useCallback } from "react";

import { getNoteKey, saveDraft, getDraft, deleteDraft } from "../helper/indexedDBHelper";

export const useNotesIndexDB = ({ userId, noteId, initialContent }) => {
  const [indexedDBKey, setIndexedDBKey] = useState(null);

  const initializeDraft = useCallback(async () => {
    const key = getNoteKey(userId, noteId);
    setIndexedDBKey(key);

    const draft = await getDraft(key);
    return draft ?? initialContent;
  }, [userId, noteId, initialContent]);

  const autoSaveDraft = useCallback(
    (content) => {
      if (indexedDBKey && content !== undefined) {
        saveDraft(indexedDBKey, content);
      }
    },
    [indexedDBKey]
  );

  const clearDrafts = useCallback(() => {
    const keyDraft = getNoteKey(userId, noteId);

    deleteDraft(keyDraft);
  }, [userId, noteId]);

  return { initializeDraft, autoSaveDraft, clearDrafts };
};
